import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import DateTime from '_class/DateTime';
import User from '_class/User';
import { getDescription } from 'helpers/content';
import { setPageTitle, setPageActions } from 'actions/header';
import { getArchivedEducationGroups, updateArchived } from 'actions/sections';
import { getMySections, getAllSections } from 'actions/user';
import { getSchoolDataForSections } from 'actions/schools';
import { searchGroups, clearSearch, searchMySections } from 'actions/search';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import { Button, Card, Checkbox, Flex, Tabs, Tab, Icon, translate } from '@haldor/ui';
import { Spinner, Expandable } from 'UI';
import { Search as SearchInput } from 'UI/Inputs';
import './_Groups.scss';
import SectionOptionForm from 'containers/Forms/SectionOptionForm';
import { getActiveSchool } from 'helpers/localstorage';

var MySections = /*#__PURE__*/function (_Component) {
  _inherits(MySections, _Component);

  var _super = _createSuper(MySections);

  function MySections(props) {
    var _this;

    _classCallCheck(this, MySections);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('sections-header-overview'));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.currentUser);

      if (user.isAdministrator()) {
        _this.props.setPageActions([{
          value: _this.props.translate('Options'),
          type: 'button',
          onClick: _this.toggleOptionModal,
          icon: 'cog_bw'
        }]);
      }

      _this.getSchoolDataForSection();

      _this.getSections();

      window.addEventListener('hashchange', _this.handleHashChange);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('hashchange', _this.handleHashChange);

      _this.props.clearSearch();
    });

    _defineProperty(_assertThisInitialized(_this), "getFilter", function () {
      var filter = '';

      if (_this.state.activeTab == 'all') {
        filter += 'UNLINKED;';
      }

      if (_this.state.activeTab == 'notconnected') {
        filter += 'UNLINKED;';
      } else {
        if (_this.state.filters.includes('mentor')) {
          filter += 'MENTOR_GROUP;';
        }

        if (_this.state.filters.includes('education')) {
          filter += 'EDUCATION_GROUP;';
        } // WE do this because user must select mentor groups or education group in the filter


        if ((filter.includes('MENTOR_GROUP') || filter.includes('EDUCATION_GROUP')) && _this.state.activeTab == 'connected') {
          filter += 'LINKED;';
        }
      } // if (this.state.filters.includes('groups_owned_by_me')) {
      // 	filter += 'OWNED_BY_ME;';
      // }


      if (!_this.state.filters.includes('archived')) {
        filter += 'ACTIVE;';
      }

      return filter;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOptionModal", function () {
      _this.setState({
        optionsModalVisible: !_this.state.optionsModalVisible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSchoolDataForSection", function () {
      var activeSchool = getActiveSchool(_this.props.currentUser.id);

      _this.props.getSchoolDataForSections(activeSchool);
    });

    _defineProperty(_assertThisInitialized(_this), "showConnectButton", function () {
      var user = new User(_this.props.currentUser);

      if (_this.props.schoolDataForSections == null) {
        return false;
      }

      if (user.isTeacher() && !user.isMentor()) {
        return _this.props.schoolDataForSections.allowManualEducationGroupConnection;
      }

      if (!user.isTeacher() && user.isMentor()) {
        return _this.props.schoolDataForSections.allowManualMentorGroupConnection;
      }

      if (user.isTeacher() && user.isMentor()) {
        return _this.props.schoolDataForSections.allowManualEducationGroupConnection || _this.props.schoolDataForSections.allowManualMentorGroupConnection;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getSections", function () {
      var nextPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var user = new User(_this.props.currentUser);

      _this.setState({
        loading: !nextPage,
        nextPageLoading: nextPage
      });

      var filter = _this.getFilter();

      if (user.isAdministrator()) {
        if (_this.state.activeTab == "allgroupsfromschool") {
          _this.props.getAllSections({
            pageIndex: _this.state.page,
            filter: filter,
            sortBy: _this.state.sort
          }).then(function () {
            _this.setState({
              loading: false,
              nextPageLoading: false
            });
          });
        } else {
          _this.props.getMySections({
            pageIndex: _this.state.page,
            filter: filter,
            sortBy: _this.state.sort
          }).then(function () {
            _this.setState({
              loading: false,
              nextPageLoading: false
            });
          });
        }
      } else {
        _this.props.getMySections({
          pageIndex: _this.state.page,
          filter: filter,
          sortBy: _this.state.sort
        }).then(function () {
          _this.setState({
            loading: false,
            nextPageLoading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getNextPage", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                page: _this.state.page + 1
              });

            case 2:
              _this.getSections(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleHashChange", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.setState({
                activeTab: window.location.hash.replace('#', ''),
                page: 1
              });

            case 2:
              if (_this.state.searchQuery != null) {
                _this.onSearch(_this.state.searchQuery);
              } else {
                _this.getSections();
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "noGroupsFound", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, _this.props.translate('no-sections-found')));
    });

    _defineProperty(_assertThisInitialized(_this), "noSearchResultFound", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, _this.props.translate('no-search-was-found')));
    });

    _defineProperty(_assertThisInitialized(_this), "cutDescription", function (description) {
      if (description == null) {
        return '';
      }

      var strippedDescription = getDescription(description).replace(/(<([^>]+)>)/ig, '');

      if (strippedDescription.length > 99) {
        return strippedDescription.slice(0, 100) + '…';
      }

      return strippedDescription;
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        selectedGroup: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeOptionsModal", function () {
      _this.setState({
        optionsModalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(values) {
        var user, filter;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(values.query.length < 3)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", false);

              case 2:
                user = new User(_this.props.currentUser);

                _this.setState({
                  loading: true,
                  searchQuery: values
                });

                filter = _this.getFilter();

                _this.setState({
                  loading: true
                });

                if (!(user.isAdministrator() && _this.state.activeTab == "allgroupsfromschool")) {
                  _context3.next = 10;
                  break;
                }

                _this.props.getAllSections({
                  pageIndex: _this.state.page,
                  filter: filter,
                  query: values.query,
                  sortBy: _this.state.sort
                }).then(function () {
                  _this.setState({
                    loading: false
                  });
                });

                _context3.next = 12;
                break;

              case 10:
                _context3.next = 12;
                return _this.props.searchMySections({
                  query: values.query,
                  filter: filter,
                  sortBy: _this.state.sort
                }).then(function () {
                  _this.setState({
                    loading: false
                  });
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "searchOnChange", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(values) {
        var user;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (values == null || values.length == 0) {
                  user = new User(_this.props.currentUser);

                  _this.setState({
                    searchQuery: null
                  });

                  _this.props.clearSearch();

                  if (user.isAdministrator() && _this.state.activeTab == "allgroupsfromschool") {
                    _this.getSections();
                  }
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleArchived", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(group) {
        var result, _result;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (group.archived) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 3;
                return swal.fire({
                  title: _this.props.translate('are-you-sure'),
                  html: _this.props.translate('Both the group and the Microsoft Team will be archived.<br /><br />Do you want to archive this group?'),
                  showCancelButton: true,
                  focusConfirm: false,
                  cancelButtonText: _this.props.translate('No'),
                  confirmButtonText: _this.props.translate('Yes')
                });

              case 3:
                result = _context5.sent;

                if (!(result.dismiss != null)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", true);

              case 6:
                _context5.next = 13;
                break;

              case 8:
                _context5.next = 10;
                return swal.fire({
                  title: _this.props.translate('are-you-sure'),
                  text: _this.props.translate('Are you sure you want to reset this group?'),
                  showCancelButton: true,
                  cancelButtonText: _this.props.translate('No'),
                  confirmButtonText: _this.props.translate('Yes')
                });

              case 10:
                _result = _context5.sent;

                if (!(_result.dismiss != null)) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt("return", true);

              case 13:
                group.courses = null;

                _this.setState({
                  loadingGroups: [].concat(_toConsumableArray(_this.state.loadingGroups), [group.id])
                });

                _this.props.updateArchived(group).then(function () {
                  _this.setState({
                    loadingGroups: _toConsumableArray(_this.state.loadingGroups.filter(function (lg) {
                      return lg != group.id;
                    }))
                  });
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleFilter", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(filter) {
        var filters;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                filters = _this.state.filters;

                if (filters.includes(filter)) {
                  filters = filters.filter(function (f) {
                    return f != filter;
                  });
                } else {
                  filters.push(filter);
                }

                _context6.next = 4;
                return _this.setState({
                  filters: filters,
                  page: 1
                }, function () {
                  var currentUser = _this.props.currentUser;
                  localStorage.setItem('group-filters:' + currentUser.id, JSON.stringify(_this.state.filters));
                });

              case 4:
                _this.setState({
                  loading: true
                });

                _this.getSections();

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onSortChange", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(event) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this.setState({
                  sort: event.target.value,
                  page: 1
                }, function () {
                  var currentUser = _this.props.currentUser;
                  localStorage.setItem('group-sort:' + currentUser.id, _this.state.sort);
                });

              case 2:
                _this.setState({
                  loading: true
                });

                _this.getSections();

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "connectGroup", function (group) {
      _this.setState({
        selectedGroup: group
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearchResult", function () {
      var searchResults = _this.props.searchResults;

      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", null, searchResults != null && searchResults.length == 0 ? _this.noSearchResultFound() : null, searchResults != null && searchResults.length > 0 ? searchResults.map(_this.renderGroup) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupResult", function () {
      var groups = _this.props.groups;

      var filter = _this.getFilter();

      var showResult = filter.includes('MENTOR_GROUP') || filter.includes('EDUCATION_GROUP') || filter.includes('UNLINKED');

      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", null, !_this.state.loading && groups != null && groups.length == 0 || !showResult ? _this.noGroupsFound() : null, groups != null && groups.length > 0 && showResult ? groups.map(_this.renderGroup) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroup", function (group, index) {
      var user = new User(_this.props.currentUser);
      var loading = _this.state.loadingGroups.indexOf(group.id) > -1;
      var events = group.events;
      var element = Link;

      if (group.id == 0) {
        element = null;
      }

      if (_this.state.filters == null || _this.state.filters.length == 0) {
        return null;
      }

      var cardTitle = /*#__PURE__*/React.createElement("div", {
        className: "group-header"
      }, /*#__PURE__*/React.createElement("span", {
        className: "header-title"
      }, group.title), !user.isStudent() ? group.id != 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "card-meta outline",
        style: {
          marginLeft: '.75rem',
          borderColor: '#19db6c'
        }
      }, _this.props.translate('Connected')), group.lastSynced != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '.75rem'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Sync"
      }), "".concat(new DateTime(group.lastSynced).getDateStamp(), ", ").concat(new DateTime(group.lastSynced).getTime())) : null) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta outline",
        style: {
          marginLeft: '.75rem',
          borderColor: '#efc24c'
        }
      }, _this.props.translate('Not connected')) : null, group.archived ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '.75rem'
        }
      }, _this.props.translate('Archived')) : null);
      return /*#__PURE__*/React.createElement(Card, {
        element: element,
        to: "/groups/".concat(group.id),
        style: {
          marginBottom: '0.75rem'
        },
        key: 'group-' + group.id + '-' + index
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: cardTitle,
        open: _this.state.expand
      }, /*#__PURE__*/React.createElement(Flex, {
        top: true,
        space: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "description size-14"
      }, _this.cutDescription(group.description)), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "size-14"
      }, events != null ? events.map(function (event, index) {
        return /*#__PURE__*/React.createElement(Flex, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "event-date"
        }, new DateTime(event.created).getDateStamp()), /*#__PURE__*/React.createElement("div", {
          className: "event-text"
        }, _this.props.translate(event.event), event.createdBy != null ? ' • ' + event.createdBy.firstName + ' ' + event.createdBy.lastName : null));
      }) : null) : null)), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "meta-container",
        style: {
          marginTop: '.5rem'
        }
      }, group.type != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate(group.type)) : null, group.userRole == 'OWNER' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate('Owner')) : null) : null), !user.isStudent() && (user.isAdministrator() || group.userRole == 'OWNER') ? /*#__PURE__*/React.createElement("div", {
        className: "group-actions"
      }, group.id == 0 && _this.showConnectButton() && (user.isAdministrator || group.userRole == 'OWNER') ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this.connectGroup(group);
        }
      }, _this.props.translate('Connect'))) : null, group.id != 0 && group.userRole == 'OWNER' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: loading,
        onClick: function onClick(e) {
          e.preventDefault();

          _this.toggleArchived(group);
        }
      }, loading ? /*#__PURE__*/React.createElement(Spinner, null) : null, group.archived ? _this.props.translate('Restore') : _this.props.translate('Archive')))) : null) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function () {
      return _this.setState({
        expand: !_this.state.expand
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFoldButton", function () {
      return /*#__PURE__*/React.createElement(Flex, {
        end: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "all-fold-button color--meta ".concat(_this.state.expand ? 'open' : 'closed'),
        onClick: _this.toggleExpand
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), _this.state.expand ? _this.props.translate('Hide description') : _this.props.translate('Show description')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilters", function () {
      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(SearchInput, {
        autoSearch: true,
        placeholder: _this.props.translate('Search group'),
        onSubmit: _this.onSearch,
        onChange: _this.searchOnChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          margin: 0
        }
      }, _this.props.translate('Sort')), /*#__PURE__*/React.createElement("select", {
        name: "sortorder",
        onChange: _this.onSortChange,
        value: _this.state.sort
      }, /*#__PURE__*/React.createElement("option", {
        value: "TITLE"
      }, _this.props.translate('Group name ascending (A-Z)')), /*#__PURE__*/React.createElement("option", {
        value: "TITLE_DESC"
      }, _this.props.translate('Group name descening (Z-A)')), /*#__PURE__*/React.createElement("option", {
        value: "LINKED_DATE"
      }, _this.props.translate('Connection date, ascending A-Z')), /*#__PURE__*/React.createElement("option", {
        value: "LINKED_DATE_DESC"
      }, _this.props.translate('Connection date, descending Z-A')), /*#__PURE__*/React.createElement("option", {
        value: "CREATED_DATE"
      }, _this.props.translate('Created date, ascending A-Z')), /*#__PURE__*/React.createElement("option", {
        value: "CREATED_DATE_DESC"
      }, _this.props.translate('Created date, descending Z-A')))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          margin: 0
        }
      }, _this.props.translate('Filter')), user.isMentor() && user.isTeacher() || user.isAdministrator() ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
        label: _this.props.translate('Education groups'),
        value: _this.state.filters.indexOf('education') > -1,
        onChange: function onChange() {
          return _this.toggleFilter('education');
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: _this.props.translate('Mentor groups'),
        value: _this.state.filters.indexOf('mentor') > -1,
        onChange: function onChange() {
          return _this.toggleFilter('mentor');
        }
      })) : null, _this.state.filters.indexOf('mentor') > -1 || _this.state.filters.indexOf('education') > -1 ? /*#__PURE__*/React.createElement(Checkbox, {
        label: _this.props.translate('Show archived'),
        value: _this.state.filters.indexOf('archived') > -1,
        onChange: function onChange() {
          return _this.toggleFilter('archived');
        }
      }) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNotConnectedErrorMessages", function () {
      var user = new User(_this.props.currentUser);

      if (user != null && !user.isMentor() && !user.isTeacher()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "disabled-connect-button"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert",
          bw: true
        }), _this.props.translate('To connect groups, you must have the role of teacher or mentor.'));
      }

      if (!_this.showConnectButton()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "disabled-connect-button"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert",
          bw: true
        }), _this.props.translate('You are not allowed to connect groups to this school because the administrator has disabled that functionality.'));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupList", function () {
      var user = new User(_this.props.currentUser);
      var searchQuery = _this.state.searchQuery;

      if (user.isStudent()) {
        return /*#__PURE__*/React.createElement("div", null, _this.renderFoldButton(), _this.renderGroupResult());
      }

      return /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        route: "connected",
        title: _this.props.translate('Connected groups')
      }, _this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, _this.renderFoldButton(), searchQuery != null ? _this.renderSearchResult() : _this.renderGroupResult())), /*#__PURE__*/React.createElement(Tab, {
        route: "notconnected",
        title: _this.props.translate('Not connected groups')
      }, _this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, _this.renderNotConnectedErrorMessages(), _this.renderFoldButton(), searchQuery != null ? _this.renderSearchResult() : _this.renderGroupResult())), user.isAdministrator() ? /*#__PURE__*/React.createElement(Tab, {
        route: "allgroupsfromschool",
        title: _this.props.translate('All groups in this school')
      }, _this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, _this.renderFoldButton(), _this.renderGroupResult())) : null);
    });

    var activeTab = 'linked';
    var _filters = ['education'];
    var sort = 'TITLE';

    var _user = new User(props.currentUser);

    if (!_user.isStudent()) {
      _filters.push('archived');
    }

    if (_user.isMentor()) {
      _filters.push('mentor');
    }

    if (window.location.hash.replace('#', '') != '') {
      activeTab = window.location.hash.replace('#', '');
    }

    if (localStorage.getItem('group-filters:' + props.currentUser.id) != null) {
      _filters = JSON.parse(localStorage.getItem('group-filters:' + props.currentUser.id));
    }

    if (localStorage.getItem('group-sort:' + props.currentUser.id) != null) {
      sort = localStorage.getItem('group-sort:' + props.currentUser.id);
    }

    _this.state = {
      activeTab: activeTab,
      expand: false,
      loading: false,
      selectedGroup: null,
      loadingGroups: [],
      nextPageLoading: false,
      page: 1,
      sort: sort,
      filters: _filters,
      optionsModalVisible: false
    };
    return _this;
  }

  _createClass(MySections, [{
    key: "render",
    value: function render() {
      var _this$props$groups, _this$props$groups2;

      var user = new User(this.props.currentUser);
      var filter = this.getFilter();
      var showResult = filter.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "page groups"
      }, !user.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.selectedGroup != null,
        onClose: this.closeModal,
        title: this.props.translate('Connect')
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: this.closeModal,
        section: this.state.selectedGroup,
        connectView: true
      })) : null, user.isAdministrator() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.optionsModalVisible,
        onClose: this.closeOptionsModal,
        title: this.props.translate('Options'),
        type: "small news"
      }, /*#__PURE__*/React.createElement(SectionOptionForm, {
        onAbort: this.closeOptionsModal,
        allowManualConnection: this.props.schoolDataForSections
      })) : null, !user.isStudent() ? this.renderFilters() : null, this.renderGroupList(), location.hash != '#search' && this.state.searchQuery == null && ((_this$props$groups = this.props.groups) === null || _this$props$groups === void 0 ? void 0 : _this$props$groups.length) % 20 < 1 && ((_this$props$groups2 = this.props.groups) === null || _this$props$groups2 === void 0 ? void 0 : _this$props$groups2.length) > 0 && this.state.filters.length > 0 && showResult ? /*#__PURE__*/React.createElement("div", {
        className: "df jcc",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.getNextPage
      }, this.state.nextPageLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null, this.props.translate('Show more'))) : null);
    }
  }]);

  return MySections;
}(Component);

function mapStateToProps(state) {
  return {
    educationGroups: state.sections.educationGroups,
    archivedEducationGroups: state.sections.archivedEducationGroups,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    groups: state.user.mySections,
    searchResults: state.Search.groups,
    schoolDataForSections: state.School.schoolDataForSection
  };
}

export default connect(mapStateToProps, {
  getArchivedEducationGroups: getArchivedEducationGroups,
  setPageTitle: setPageTitle,
  updateArchived: updateArchived,
  getMySections: getMySections,
  searchGroups: searchGroups,
  clearSearch: clearSearch,
  getAllSections: getAllSections,
  searchMySections: searchMySections,
  getSchoolDataForSections: getSchoolDataForSections,
  setPageActions: setPageActions
})(MySections);